import React, { useState } from 'react';

export default function PaymongoTest() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const startCheckout = async () => {
    setLoading(true);
    setError('');

    try {
      const response = await fetch('/api/paymongo/test-checkout/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
      });
      const data = await response.json();

      if (!response.ok || !data.checkout_url) {
        throw new Error(data.error || 'Could not start checkout.');
      }

      window.location.href = data.checkout_url;
    } catch (checkoutError) {
      setError(checkoutError.message);
      setLoading(false);
    }
  };

  return (
    <section className="mx-auto max-w-lg space-y-5 rounded-2xl border border-brand-gold/30 bg-white/[0.04] p-6 text-center shadow-xl">
      <div>
        <p className="text-sm font-semibold uppercase tracking-widest text-brand-gold">PayMongo test</p>
        <h1 className="mt-2">Echo Jham Test Ticket</h1>
        <p className="mt-2 text-slate-300">PHP 500.00</p>
      </div>
      <button type="button" onClick={startCheckout} disabled={loading} className="btn-primary w-full disabled:cursor-wait disabled:opacity-60">
        {loading ? 'Opening checkout...' : 'Pay with PayMongo (Test PHP 500)'}
      </button>
      {error && <p role="alert" className="text-sm text-rose-300">{error}</p>}
    </section>
  );
}